import fetch from '@/plugin/axios'

// 添加类目
export function addArticleCategory (query) {
  return fetch({
    url: '/api/common/article-category/add',
    method: 'Post',
    data: query
  })
}

// 类目列表
export function getCategoryList () {
  return fetch({
    url: '/api/common/article-category/list',
    method: 'Get'
  })
}

// 修改类目
export function editCategory (id, query) {
  return fetch({
    url: '/api/common/article-category/update/' + id,
    method: 'Post',
    data: query
  })
}

// 添加文章
export function addArticle (query) {
  return fetch({
    url: '/api/common/article/add',
    method: 'Post',
    data: query
  })
}

// 文章列表
export function getArticleList (query) {
  return fetch({
    url: '/api/common/article/list',
    method: 'Post',
    data: query
  })
}

// 上下架
export function editShelves (id, query) {
  return fetch({
    url: '/api/common/article/status/' + id,
    method: 'Post',
    params: query
  })
}

// 修改文章
export function editArticle (id, query) {
  return fetch({
    url: '/api/common/article/update/' + id,
    method: 'Post',
    data: query
  })
}

// 文章详情
export function getArticleDetail (id) {
  return fetch({
    url: '/api/common/article/info/' + id,
    method: 'Get'
  })
}
